<template>
	<div>
		<el-dialog title="提示" :visible.sync="visible" :close-on-click-modal="false" :before-close="beforeClose" width="400px">
			<p class="font-h4-regular yx-color-text-primary">
				取消认领后达人将流回团队公海展示【无人认领】状态，同时原进行中合作进度/样品订单将自动关闭，重新认领达人将从【线索】状态开始跟进
			</p>
			<div slot="footer" class="footer-dialog">
				<el-button @click="beforeClose">取 消</el-button>
				<el-button type="primary" @click="confirm">确 认</el-button>
			</div>
		</el-dialog>
		<cancelClaimTipsDialog ref="cancelClaimTipsDialog" @refresh="refresh" />
	</div>
</template>
<script>
import cancelClaimTipsDialog from '../cancelClaimTipsDialog/index.vue';
import { cancelAnchorCancelOne, cancelAnchorBatchCancel } from '@/api/talentCRM';
export default {
	components: {
		cancelClaimTipsDialog,
	},
	props: {
		platform_id: {
			type: [Number, String],
			default: '1',
		},
	},
	data() {
		return {
			visible: false,
			id: '',
			type: 'single',
		};
	},
	methods: {
		show(id = '', type = 'single') {
			this.type = type;
			this.id = id;
			this.visible = true;
		},
		async confirm() {
			const api = {
				single: cancelAnchorCancelOne,
				batch: cancelAnchorBatchCancel,
			};
			const params = {
				single: {
					p_id: this.id,
					platform_id: this.platform_id,
				},
				batch: {
					p_ids: this.id,
					platform_id: this.platform_id,
				},
			};
			await api[this.type](params[this.type]);
			if (this.type === 'single') {
				this.$message.success('取消认领成功！');
			} else {
				this.$refs.cancelClaimTipsDialog.show();
			}

			this.$emit('refresh');
			this.beforeClose();
		},
		refresh() {
			this.$emit('handleOpenReconds');
		},
		beforeClose() {
			this.id = '';
			this.type = 'single';
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped></style>
